var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{staticClass:"dashboard-units",attrs:{"items":_vm.items,"theme":"border","force-header":""},scopedSlots:_vm._u([{key:_vm.value,fn:function(){return [_c(_vm.settings.component,{tag:"component"})]},proxy:true}],null,true),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }